import * as salaryConstant from './constants'

export const salaryReportNvkdRequest = (formData) => {
  return {
    type: salaryConstant.SALARY_REPORT_NVKD_REQUESTING,
    payload: formData
  }
}

export const salaryReportNvkdSuccess = (data) => {
  return {
    type: salaryConstant.SALARY_REPORT_NVKD_SUCCESS,
    payload: data
  }
}

export const salaryReportNvkdError = (error) => {
  return {
    type: salaryConstant.SALARY_REPORT_NVKD_ERROR,
    payload: error
  }
}
export const salaryReportListRequest = (formData) => {
  return {
    type: salaryConstant.SALARY_REPORT_LIST_REQUESTING,
    payload: formData
  }
}

export const salaryReportListSuccess = (data) => {
  return {
    type: salaryConstant.SALARY_REPORT_LIST_SUCCESS,
    payload: data
  }
}

export const salaryReportListError = (error) => {
  return {
    type: salaryConstant.SALARY_REPORT_LIST_ERROR,
    payload: error
  }
}

export const reportExportXlsRequest = (formData, callback) => {
  return {
    type: salaryConstant.REPORT_EXPORT_XLS_REQUESTING,
    payload: formData,
    callback
  }
}

export const reportExportXlsSuccess = (data) => {
  return {
    type: salaryConstant.REPORT_EXPORT_XLS_SUCCESS,
    payload: data
  }
}

export const reportExportXlsError = (error) => {
  return {
    type: salaryConstant.REPORT_EXPORT_XLS_ERROR,
    payload: error
  }
}


// WEBPACK FOOTER //
// ./src/views/Reports/SalaryReport/actions.js